import { theme as origTheme } from '@chakra-ui/react';

export const Alert = {
  variants: {
    solid: props => {
      const { status } = props;

      if (status !== 'success') {
        return origTheme?.components?.Alert?.variants?.solid?.(props);
      }

      return {
        container: {
          bg: `brand.500`,
        },
      };
    },
  },
};
